import React from "react";
import liracrypt from "../components/Liracrypt/liracrypt";
import ApiErrorComp from "../components/ApiErrorComp/ApiErrorComp";
import SessionError from "../components/ApiErrorComp/SessionError";
import { LoadingOutlined } from "@ant-design/icons";
import AntdCardComponent from "../components/SCM/CardComponent";
import AmchartsCardComponent from "../components/AmchartsSCM/CardComponent";

function Charts({ setPageHeader }) {
  setPageHeader("Charts");

  const [card1, setCard1] = React.useState(null);
  const [card2, setCard2] = React.useState(null);
  const [card3, setCard3] = React.useState(null);
  const [card4, setCard4] = React.useState(null);
  const [card5, setCard5] = React.useState(null);
  const [card6, setCard6] = React.useState(null);

  const [amCard1, setAmCard1] = React.useState(null);
  const [amCard2, setAmCard2] = React.useState(null);
  const [amCard3, setAmCard3] = React.useState(null);

  const [loginError, setLoginError] = React.useState(false);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    liracrypt
      .get("/textapi", { dn: "DemoCard01" })
      .then((res, req) => {
        setCard1(res.data);
        
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response !== undefined) {
          if (err.response.status !== 401) {
            ApiErrorComp(err.response.status);
          } else {
            setLoginError(true);
          }
        }
      });

    liracrypt
      .get("/textapi", { dn: "DemoCard02" })
      .then((res, req) => {
        setCard2(res.data);
        
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response !== undefined) {
          if (err.response.status !== 401) {
            ApiErrorComp(err.response.status);
          } else {
            setLoginError(true);
          }
        }
      });

    liracrypt
      .get("/textapi", { dn: "DemoCard03" })
      .then((res, req) => {
        setCard3(res.data);
        
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response !== undefined) {
          if (err.response.status !== 401) {
            ApiErrorComp(err.response.status);
          } else {
            setLoginError(true);
          }
        }
      });

    liracrypt
      .get("/textapi", { dn: "DemoCard04" })
      .then((res, req) => {
        setCard4(res.data);
        
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response !== undefined) {
          if (err.response.status !== 401) {
            ApiErrorComp(err.response.status);
          } else {
            setLoginError(true);
          }
        }
      });

    liracrypt
      .get("/textapi", { dn: "DemoCard05" })
      .then((res, req) => {
        setCard5(res.data);
        
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response !== undefined) {
          if (err.response.status !== 401) {
            ApiErrorComp(err.response.status);
          } else {
            setLoginError(true);
          }
        }
      });

    liracrypt
      .get("/textapi", { dn: "DemoCard06" })
      .then((res, req) => {
        setCard6(res.data);
        
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response !== undefined) {
          if (err.response.status !== 401) {
            ApiErrorComp(err.response.status);
          } else {
            setLoginError(true);
          }
        }
      });

    liracrypt
      .get("/textapi", { dn: "DemoGraph01" })
      .then((res, req) => {
        setAmCard1(res.data);
        
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response !== undefined) {
          if (err.response.status !== 401) {
            ApiErrorComp(err.response.status);
          } else {
            setLoginError(true);
          }
        }
      });

    liracrypt
      .get("/textapi", { dn: "DemoGraph02" })
      .then((res, req) => {
        setAmCard2(res.data);
        
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response !== undefined) {
          if (err.response.status !== 401) {
            ApiErrorComp(err.response.status);
          } else {
            setLoginError(true);
          }
        }
      });

    liracrypt
      .get("/textapi", { dn: "DemoGraph03" })
      .then((res, req) => {
        setAmCard3(res.data);
        
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response !== undefined) {
          if (err.response.status !== 401) {
            ApiErrorComp(err.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  }, []);

  return (
    <>
      <SessionError visible={loginError} />
      {card1 ? (
        <AntdCardComponent data={card1.data} config={card1.config} />
      ) : (
        <></>
      )}

      {card2 ? (
        <AntdCardComponent data={card2.data} config={card2.config} />
      ) : (
        <></>
      )}

      {card3 ? (
        <AntdCardComponent data={card3.data} config={card3.config} />
      ) : (
        <></>
      )}

      {card4 ? (
        <AntdCardComponent data={card4.data} config={card4.config} />
      ) : (
        <></>
      )}

      {card5 ? (
        <AntdCardComponent data={card5.data} config={card5.config} />
      ) : (
        <></>
      )}

      {card6 ? (
        <AntdCardComponent data={card6.data} config={card6.config} />
      ) : (
        <></>
      )}

      {amCard1 ? (
        <AmchartsCardComponent data={amCard1.data} config={amCard1.config} />
      ) : (
        <></>
      )}

      {amCard2 ? (
        <AmchartsCardComponent data={amCard2.data} config={amCard2.config} />
      ) : (
        <></>
      )}

      {amCard3 ? (
        <AmchartsCardComponent data={amCard3.data} config={amCard3.config} />
      ) : (
        <></>
      )}
    </>
  );
}

export default Charts;
